import { Injectable } from '@angular/core';

import { MemoryCacheRepository } from './memory-cache.repository';
import { SelectedProductInterface } from '../data';

@Injectable()
export class SelectedProductCacheRepository extends MemoryCacheRepository<SelectedProductInterface[]> {}
